import { useEffect, useRef, useState } from "react";
import ClientInformation from "../ClientInformation";

const Ultrasound = () => {
  const [value, setValue] = useState(
    `1. Liver:  

2. Gall Bladder:  

3. Spleen:  

4. Kidneys:  

   - Left kidney: x cm  
   
   - Right kidney: x cm  

5. Urinary bladder:  

  - Wall thickness: x cm  

6. Peritoneum:  

7. Prostate:  
 
 Interpretation/Comments: `,
  );

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      const element = textareaRef.current;
      const newHeight = element.scrollHeight;

      // Only update if the height actually needs to change
      if (element.style.height !== `${newHeight}px`) {
        element.style.height = "auto"; // Reset first
        element.style.height = `${newHeight}px`; // Then set new height
      }
    }
  };

  return (
    <div>
      <ClientInformation />
      <p className="text-center font-bold inline-block border-b-2 border-gray-500 ">FINDINGS :</p>

      <div className="flex  gap-2 print:gap-1 w-full mt-2 print:-mb-2 ">
        <textarea
          ref={textareaRef}
          className="w-full border p-2 print:hidden text-xs resize-none scrollbar-thin"
          value={value}
          autoFocus
          onInput={adjustHeight} // Adjusts height on input instead of useEffect
          onChange={(e) => setValue(e.target.value)}
          style={{ overflowY: "auto", scrollbarWidth: "thin", fontSize: "14px" }}
        />
        <div className="hidden print:block  w-full print:border-none p-2 text-xs whitespace-pre-wrap">{value}</div>
      </div>

      <div className="flex items-center gap-2 print:mt-3 mt-5">
        <p className="text-sm">Doctor's Name:</p>
        <input type="text" className="text-sm w-[400px] border p-1" />
      </div>

      <p className="font-bold mt-3 italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default Ultrasound;
